import { Quote } from '../models';
import { useDocument } from './useDocument';

export function useQuote(id: string | 'new' = 'new') {
  return useDocument<Quote>('/Quotes', id);
}
